import React from 'react';
import { Link } from 'react-router-dom';
import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const OwlCarouselSliderHomeFacility = (props) => {	
	 const options = {
	 	loop:true,
		nav:false,
		dots: true,
		navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
		responsive:{
			0:{
				items:1
			},
			
			480:{
				items:1
			},	
			
			540:{
				items:2
			},	
				
					
			1024:{
				items:3,
				
			},
			
			1360:{
				items:4
			},
			
			1400:{
				items:5
			}
		}
    };
  	
    return(
	<>					
		<OwlCarousel className="home-carousel-2 m-b30 bg-repeat" {...options}>	
		{props.data.map((item, index) => (
		     <div className="item" key={index}>
				<div className="wt-box p-t50">
					<div className="wt-media site-text-primary m-b20 radius-bx circle-effect-1 wt-img-overlay11">					
							<img src={item.src} alt={item.alt} className="radius-bx " />
							<div className="text-center p-a30 wt-img-overlay11-content text-white">
								 <div className="overlay-11-detail">
									 <div className="overlay-11-info">
										 <p className="m-b0">
											{item.description}
										</p>
										 <h4 className="m-b0"><Link to={item.link}>More</Link></h4>
									 </div>
								 </div>
								<div className="site-bg-primary bg-color radius-bx opacity-08"></div>
							</div>
						
						<div className="price-tag">
							<div className="price-circle bg-white text-center site-text-primary radius-bx">
								<span className="font-18">{item.icon}</span>
							</div>
						</div>
					</div>
					<div className="wt-info p-t30 text-center">
						<h2>{item.title}</h2>
					</div>
				</div>
			</div>			
		 ))}							  
		</OwlCarousel>	
		
    </>
    )
}
export default OwlCarouselSliderHomeFacility;